/* eslint-disable no-autofix/jsdoc/require-jsdoc */
import { useQueryClient } from '@tanstack/react-query';

import { getTsWarehousingConsignmentsClient } from '@/api/warehousing-consignments.client';
import type { DispatchedConsignmentStatus } from '@montugroup/contracts-warehousing-api';

export type UseGetPharmacistShipmentsParams = {
  pageSize: number;
  referenceFilter?: string;
  statusFilter?: DispatchedConsignmentStatus[];
  sortField?: string;
  sortDirection?: 'asc' | 'desc';
  beforeCursor?: string | null;
  afterCursor?: string | null;
  signal?: AbortSignal;
};

const client = getTsWarehousingConsignmentsClient();

const useGetPharmacistShipments = () => {
  const queryClient = useQueryClient();
  return client.listConsignments.useMutation({
    meta: {
      error: {
        showToast: true,
        log: 'Failed to retrieve list consignments for pharmacist',
        message: 'Something went wrong while retrieving the shipments',
      },
    },
    onSuccess: (result) => {
      queryClient.setQueryData(client.listConsignments.keys, result);
    },
  });
};

export default useGetPharmacistShipments;
